<script setup>
  import { onMounted, onBeforeUnmount, watch } from 'vue';

  const props = defineProps({
    schema: {
      type: [Object, Array],
      required: true,
    },
    id: {
      type: String,
      default: () => `schema-${Date.now()}-${Math.random()}`,
    },
  });

  let scriptElement = null;

  function addSchema() {
    removeSchema();

    scriptElement = document.createElement('script');
    scriptElement.type = 'application/ld+json';
    scriptElement.id = props.id;
    scriptElement.textContent = JSON.stringify(props.schema);

    document.head.appendChild(scriptElement);
  }

  function removeSchema() {
    if (scriptElement && scriptElement.parentNode) {
      scriptElement.parentNode.removeChild(scriptElement);
      scriptElement = null;
    }
  }

  onMounted(() => {
    addSchema();
  });

  onBeforeUnmount(() => {
    removeSchema();
  });

  watch(
    () => props.schema,
    () => {
      addSchema();
    },
    { deep: true }
  );
</script>
